import useWebProduct from "../../../../../components/state/useWebProduct";
import {ProductPurchaseInfo} from "../../../../../res/product/productPurchaseInfo";
import ProductInput from "../../../product/ProductInput";
import BinIcon from "../../../../../res/icon/BinIcon";
import {formatDisplayPrice} from "../../../../../res/dataServices/pricing";

const CartLineInput = ({ product }) => {

    const deleteLine = () => {
        product.setQuantityEntered(0);
    }

    return (
        <div className="cart-line-input">
            <ProductInput
                product={product}
                includeDeleteButton
            />
            <div className="cart-line-delete" onClick={deleteLine}>
                <BinIcon />
            </div>
        </div>
    )
}

const CartLine = ({ line }) => {

    const { webProduct } = useWebProduct({orderLineID: line.id, product: line.M_Product_ID });

    if(webProduct.isNotAvailable()) return null;

    const product = ProductPurchaseInfo.getCartDisplayProduct(webProduct);
    const preDiscountPrice = product.getUomStdDisplayPrice();
    const currentUnitPrice = formatDisplayPrice(line.PriceEntered);

    const showDiscount = preDiscountPrice !== currentUnitPrice;

    return (
        <div className="cart-line-grid">
            <div>
                <p className="cart-line-code">{product.getValue()}</p>
                <p className="cart-line-h2">{product.getName()} {product.getCaseDescription()}</p>
            </div>
            <p className="cart-line-h2 cart-h-r">
                {showDiscount &&
                    <>
                        <span className="cart-discount">
                            {preDiscountPrice}
                        </span>
                        {' '}
                    </>
                }
                {" " + currentUnitPrice}
            </p>
            <CartLineInput product={product} />
            <p className="cart-line-h2 cart-h-r">{product.getDisplayPrice()}</p>
        </div>
    )
}

export default CartLine;
